import { render, staticRenderFns } from "./SignOutView.vue?vue&type=template&id=cb0a319c&scoped=true"
import script from "./SignOutView.vue?vue&type=script&lang=ts"
export * from "./SignOutView.vue?vue&type=script&lang=ts"
import style0 from "./SignOutView.vue?vue&type=style&index=0&id=cb0a319c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a319c",
  null
  
)

export default component.exports